export enum StorageKeys {
  PopupCallback = 'ngoidc:isPopupCallback'
}
